// Layout
import MorningCoinLayout from "./MorningCoinLayout";

// Pages
import EarnCoinReportPage from "./pages/EarnCoinReportPage";
import GiftBoxReportPage from "./pages/GiftBoxReportPage";
import MNCReportDownloadPage from "./pages/MNCReportDownloadPage";
import TransactionHistoryReportPage from "./pages/TransactionHistoryReportPage";
import TransferHomeReportPage from "./pages/TransferHomeReportPage";
import WalletBalanceReportPage from "./pages/WalletBalanceReportPage";
import WalletToEarnUserPage from "./pages/WalletToEarnUserPage";

export const morningCoinRoutes = {
  path: "morning-coin",
  component: MorningCoinLayout,
  children: [
    {
      name: "EarnCoinReportPage",
      path: "earn-coin-report",
      component: EarnCoinReportPage
    },
    {
      name: "TransferHomeReportPage",
      path: "transfer-home-report",
      component: TransferHomeReportPage
    },
    {
      name: "WalletToEarnUserPage",
      path: "earn-user-wallet",
      component: WalletToEarnUserPage
    },
    {
      name: "WalletBalanceReportPage",
      path: "wallet-balance-report",
      component: WalletBalanceReportPage,
    },
    {
      name: "TransactionHistoryReportPage",
      path: "transaction-history-report/:userId",
      component: TransactionHistoryReportPage,
    },
    {
      name: "GiftBoxReportPage",
      path: "gift-box-report",
      component: GiftBoxReportPage,
    },
    {
      name: "MNCReportDownloadPage",
      path: "mnc-report-download",
      component: MNCReportDownloadPage,
    },
  ]
};
